/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RosterInputs */

const th_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายชื่อผู้เล่น`)
};

const en_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roster`)
};

const ja_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロースター`)
};

const zh_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阵容`)
};

const es_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantilla`)
};

const pt_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elenco`)
};

const id_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skuad`)
};

const fr_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effectif`)
};

const tl_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squad`)
};

const vi_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội hình`)
};

const ko_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수단`)
};

const de_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kader`)
};

const ru_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Состав`)
};

const tr_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kadro`)
};

const it_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rosa`)
};

const pl_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skład`)
};

const uk_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Склад`)
};

const hi_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम`)
};

const ar_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التشكيلة`)
};

const ms_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skuad`)
};

const bn_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল`)
};

const zh_tw2_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名單`)
};

const zh_hk2_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名單`)
};

const ur_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسکواڈ`)
};

const fa_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فهرست تیم`)
};

const sw_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kikosi`)
};

const nl_roster = /** @type {(inputs: RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectie`)
};

/**
* | output |
* | --- |
* | "Roster" |
*
* @param {RosterInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const roster = /** @type {((inputs?: RosterInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RosterInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_roster(inputs)
	if (locale === "ja") return ja_roster(inputs)
	if (locale === "zh") return zh_roster(inputs)
	if (locale === "es") return es_roster(inputs)
	if (locale === "pt") return pt_roster(inputs)
	if (locale === "id") return id_roster(inputs)
	if (locale === "fr") return fr_roster(inputs)
	if (locale === "tl") return tl_roster(inputs)
	if (locale === "vi") return vi_roster(inputs)
	if (locale === "ko") return ko_roster(inputs)
	if (locale === "de") return de_roster(inputs)
	if (locale === "ru") return ru_roster(inputs)
	if (locale === "tr") return tr_roster(inputs)
	if (locale === "it") return it_roster(inputs)
	if (locale === "pl") return pl_roster(inputs)
	if (locale === "uk") return uk_roster(inputs)
	if (locale === "hi") return hi_roster(inputs)
	if (locale === "ar") return ar_roster(inputs)
	if (locale === "ms") return ms_roster(inputs)
	if (locale === "bn") return bn_roster(inputs)
	if (locale === "zh-TW") return zh_tw2_roster(inputs)
	if (locale === "zh-HK") return zh_hk2_roster(inputs)
	if (locale === "ur") return ur_roster(inputs)
	if (locale === "fa") return fa_roster(inputs)
	if (locale === "sw") return sw_roster(inputs)
	if (locale === "nl") return nl_roster(inputs)
	return en_roster(inputs)
});